import { Outlet, Link } from 'react-router-dom';
import Navbar from './Navbar';
import { COMPANY, LEGAL_ROUTES, SUPPLEMENT_DISCLAIMER } from '../pages/legal/legalConstants';

export default function Layout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer
        data-testid="site-footer"
        className="border-t border-border mt-16"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-3 gap-10 text-sm">
          {/* Bedrijfsidentiteit — verplicht voor Belgische e-commerce */}
          <div data-testid="footer-company-identity">
            <p className="font-serif text-lg text-foreground mb-2">
              {COMPANY.tradeName}
            </p>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {COMPANY.legalName}<br />
              <span data-testid="footer-address">
                {COMPANY.address.street}<br />
                {COMPANY.address.postalCode} {COMPANY.address.city}<br />
                {COMPANY.address.country}
              </span><br />
              BTW <span data-testid="footer-vat-number">{COMPANY.vatNumber}</span><br />
              <span data-testid="footer-rpr">{COMPANY.rpr}</span><br />
              <a
                data-testid="footer-email-link"
                href={`mailto:${COMPANY.email}`}
                className="underline hover:text-foreground"
              >
                {COMPANY.email}
              </a><br />
              <span data-testid="footer-no-phone" className="italic">
                Niet telefonisch bereikbaar
              </span>
            </p>
          </div>

          {/* Klantenservice */}
          <div>
            <p className="font-medium text-foreground mb-2">Klantenservice</p>
            <ul className="space-y-1.5 text-xs text-muted-foreground">
              <li>
                <Link to="/contact" data-testid="footer-link-contact" className="hover:text-foreground">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/verzending" data-testid="footer-link-shipping" className="hover:text-foreground">
                  Verzending &amp; levering
                </Link>
              </li>
              <li>
                <Link to="/herroepingsrecht" data-testid="footer-link-withdrawal" className="hover:text-foreground">
                  Herroepingsrecht
                </Link>
              </li>
            </ul>
          </div>

          {/* Juridisch */}
          <div>
            <p className="font-medium text-foreground mb-2">Juridisch</p>
            <ul className="space-y-1.5 text-xs text-muted-foreground">
              <li>
                <Link to="/algemene-voorwaarden" data-testid="footer-link-terms" className="hover:text-foreground">
                  Algemene voorwaarden
                </Link>
              </li>
              <li>
                <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-foreground">
                  Privacybeleid
                </Link>
              </li>
              <li>
                <Link to="/cookies" data-testid="footer-link-cookies" className="hover:text-foreground">
                  Cookiebeleid
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Voedingssupplement-disclaimer (KB/AR 29 augustus 1997) */}
        <div className="border-t border-border/60">
          <div
            data-testid="footer-supplement-disclaimer"
            className="max-w-7xl mx-auto px-6 md:px-12 py-4 text-[10px] text-muted-foreground/80 leading-relaxed text-center"
          >
            {SUPPLEMENT_DISCLAIMER}
          </div>
        </div>

        {/* Compact footer rail — hidden index of routes for crawlers / sanity */}
        <div className="hidden">
          {LEGAL_ROUTES.map(r => (
            <Link key={r.path} to={r.path}>{r.label}</Link>
          ))}
        </div>
      </footer>
    </div>
  );
}
